import {RequestPlaceDto} from './RequestPlaceDto';
import {RequestVisitorDto} from "./RequestVisitorDto";

export class VisitRequestDto {
    id: string = '';
    number: string = '';
    applyDate: string = '';
    arriveStartDate: string = '';
    arriveEndDate: string = '';
    arriveStartTime: string = '';
    arriveEndTime: string = '';
    purposeType: string = '01';
    purpose: string = '';
    status: string = '';
    applySourceType: string = '';
    hostUserId: string = '';
    hostFullName: string = '';
    hostLastName: string = '';
    hostFirstName: string = '';
    hostEmail: string = '';
    hostMobile: string = '';
    hostSupervisorId: string = '';
    hostSupervisorName: string = '';
    hostSupervisorEmail: string = '';
    hostDepartmentId: string = '';
    hostDepartmentName: string = '';
    groupFlag: string = '';
    groupVisitCode: string = '';
    workflowApplyFormId: string = '';
    visitors: Array<RequestVisitorDto> = [];
    places: Array<RequestPlaceDto> = [];

    hostStaffNumber: string = '';
    hostCompanyId: string = '';
    hostCompanyName: string = '';

    siteId: string = '';
    siteCode: string = '';
    siteName: string = '';
    remarks: string = '';
    classify: string = '';

    // 运输物品
    transportGoods: string = '';
    personalGoodsFlag: boolean = false;
    personalGoodsDescription: string = '';

    // 第二接待者
    hostName2: string = '';
    hostMobile2: string = '';
}
